import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import translate from "@insite/client-framework/Translate";
import { CountryModel, ProductModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import Constant from "@tSurya/Constants/Constant";
import createCustomerInfo from "@tSurya/Handlers/CutAndSewRugCustomerInfo/CutAndSewRugCustomerInfo";

import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import siteMessage from "@insite/client-framework/SiteMessage";
import { DatePickerPresentationProps } from "@insite/mobius/DatePicker/DatePicker";
import { DynamicDropdownPresentationProps } from "@insite/mobius/DynamicDropdown/DynamicDropdown";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import AlertTriangle from "@insite/mobius/Icons/AlertTriangle";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import Select from "@insite/mobius/Select";
import TextArea from "@insite/mobius/TextArea";
import TextField, { TextFieldPresentationProps, TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CallbackType, ErrorObjectType, InputObjectType, validate } from "@tSurya/Common/Utilities/validate";
import {
    FormErrorsStateType,
    intialErrorFormState,
    NewCustomerValidatorConfig,
    ValidatorConfigType,
} from "@tSurya/Components/CustomGetQuoteOrderPageConfig";
import submitCustomOrder from "@tSurya/Handlers/SendCustomHandler";
import { CustomOrderApiParameter } from "@tSurya/Services/SendCustomOrder";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    saveAndContinueStep3?: any;
    previousStep3?: any;
    countries?: CountryModel[];
    placeOrder?: any;
    selectedShape?: string;
    feet?: number;
    inch?: number;
    roundfeet?: number;
    roundinch?: number;
    widthFeet?: number;
    widthInch?: number;
    lengthFeet?: number;
    lengthInches?: number;
    price?: string;
    product?: ProductModel;
    currentShape?: string;
    closeHandler?: any;
    leadTime?: string;
    acctualPrice?: string;
}

const mapStateToProps = (state: CustomApplicationState) => ({
    openTradeAccountData: state.SURData.openTradeAccountStore,
    countries: getCurrentCountries(state),
    customData: getSession(state),
    userDetails: getBillToState(state, state.context.session.billToId).value,
    language: state.context.session.language,
});

const mapDispatchToProps = {
    loadCurrentCountries,
    createCustomerInfo,
    submitCustomOrder,
};

export interface CustomGetQuoteFormStyles {
    customerContainer?: InjectableCss;
    customerInfo?: InjectableCss;
    customerInfoWrapper?: InjectableCss;
    accountNumber?: TextFieldProps;
    addressLineOne?: TypographyProps;
    poNumber?: InjectableCss;
    poNumberTextBox?: TextFieldProps;
    quantityTextBox?: TextFieldProps;
    shippingContainer?: InjectableCss;
    orderDetailsContainer?: InjectableCss;
    orderDetailLabel?: InjectableCss;
    shippingLabel?: InjectableCss;
    billingLable?: InjectableCss;
    shippingField?: InjectableCss;
    customRequest?: InjectableCss;
    customRequestDropDown?: InjectableCss;
    policyContainer?: InjectableCss;
    policyheadinglabel?: InjectableCss;
    policySubheadinglabel?: InjectableCss;
    custContainer?: InjectableCss;
    custLabel?: InjectableCss;
    termsAndConditionNotes?: InjectableCss;
    custField?: InjectableCss;
    custTextBox?: TextFieldProps;
    submitButton?: InjectableCss;
    buttonContainer?: InjectableCss;
    table?: InjectableCss;
    tableTextBox?: InjectableCss;
    requestContainer?: InjectableCss;
    requestLine?: InjectableCss;
    depositContainer?: InjectableCss;
    DatePickerContainer?: InjectableCss;
    DateLabel?: InjectableCss;
    DatePicker?: DatePickerPresentationProps;
    tableCells?: InjectableCss;
    tableContainer?: InjectableCss;
    listStyle?: DynamicDropdownPresentationProps;
    dropdown?: InjectableCss;
    lableDivone?: InjectableCss;
    lableDivtwo?: InjectableCss;
    textOne?: InjectableCss;
    textAreaEmail?: InjectableCss;
    note?: InjectableCss;
    container?: InjectableCss;
    signatureTextField?: InjectableCss;
    orderDate?: InjectableCss;
    checkBoxContainer?: InjectableCss;
    checkboxData?: InjectableCss;
    checkboxText?: InjectableCss;
    informativeLine?: InjectableCss;
    informativeLineContainer?: InjectableCss;
    buttonWrapper?: InjectableCss;
    closeButton?: InjectableCss;
    sendOrder?: InjectableCss;
    sameBillingText?: InjectableCss;
    upperText?: InjectableCss;
    emailContainer?: InjectableCss;
    emailText?: InjectableCss;
    productTittle?: InjectableCss;
    contactDetail?: InjectableCss;
    sectionHeading?: InjectableCss;
    contactSection?: InjectableCss;
    contactField?: InjectableCss;
    userNameTextField?: TextFieldPresentationProps;
    emailTextField?: TextFieldPresentationProps;
    qunatityText?: InjectableCss;
    qunatityTextBox?: InjectableCss;
    Greeting?: InjectableCss;
    Link?: InjectableCss;
    shipTocheckboxCOntainer?: TypographyProps;
    billingTitle?: TypographyProps;
    termsContainer?: InjectableCss;
    creditcardFrom?: LinkPresentationProps;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const CustomGetQuoteFormStyles: CustomGetQuoteFormStyles = {
    dropdown: {
        css: css`
            + span {
                top: 7px !important;
            }
        `,
    },
    qunatityText: {
        css: css`
            margin-right: 20px;
        `,
    },
    qunatityTextBox: {
        css: css``,
    },
    userNameTextField: {
        labelProps: {
            css: css`
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.smaller};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                color: ${getColor("text.main")};
                &::placeholder {
                    font-weight: 400;
                }
            `,
        },
    },
    contactField: {
        css: css`
            width: calc(33.3333% - 20px);
            display: inline-block;
            vertical-align: top;
            margin-bottom: 20px;
            margin-right: 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: block;
                        width: 100%;
                    `,
                    css`
                        display: block;
                        width: 100%;
                    `,
                    css`
                        display: block;
                        width: 100%;
                    `,
                    null,
                    null,
                ])}
            [class^="SelectStyle"] {
                height: 40px;
            }
            [class^="FileUploadStyle"] {
                height: 40px !important;
            }
        `,
    },
    contactSection: {
        css: css`
            padding: 10px 30px;
        `,
    },

    customerInfo: {
        css: css`
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            //margin-top: 20px;
        `,
    },
    customerInfoWrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            column-gap: 30px;
            border: 1px solid ${getColor("common.border")};
            padding: 21px 32px 32px;
            width: 100%;
            height: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                    `,
                    css`
                        flex-wrap: wrap;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    accountNumber: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
            `,
            formInputWrapper: css`
                input {
                    height: 40px !important;
                    background: none !important;
                }
            `,
        },
    },
    addressLineOne: {
        css: css`
            margin-top: 10px;
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.larger};
            color: ${getColor("text.main")};
            padding: 0 30px;
        `,
    },
    poNumber: {
        css: css`
            //margin-top: 30px;
            width: 32%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                        margin-top: 20px;
                    `,
                    css`
                        width: 100%;
                        margin-top: 20px;
                    `,
                    css`
                        width: 48%;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    poNumberTextBox: {
        cssOverrides: {
            inputSelect: css`
                width: 100%;
                // margin-top: 10px;
            `,
            formField: css`
                display: flex;
                flex-wrap: wrap;
                margin-top: 28px;
                align-items: center;
                label {
                    width: 100%;
                    margin-bottom: 10px;
                    font-family: "Mulish";
                    font-style: normal;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 22px;
                    color: ${getColor("text.main")};
                }
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    height: 40px !important;
                }
            `,
        },
    },
    shippingContainer: {
        css: css`
            margin-top: 20px;
            /* border: 1px solid ${getColor("common.border")}; */
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    shippingLabel: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: #f4f3f1;
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
            display: flex;
            justify-content: space-between;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    shippingField: {
        css: css`
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            /* padding: 0 20px 20px; */
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        column-gap: 20px;
                    `,
                    css`
                        column-gap: 20px;
                    `,
                    null,
                ])}
        `,
    },
    termsAndConditionNotes: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.base};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")};
            padding: 0 30px 6px;
        `,
    },
    quantityTextBox: {
        cssOverrides: {
            inputSelect: css`
                width: auto;
            `,
            formField: css`
                /* margin-top: 14px; */
                width: 32%;
                flex-direction: column;
                align-items: center;
                label {
                    width: 100%;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 48%;
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    width: 100% !important;
                    max-width: 340px;
                    padding: 5px 12px !important;
                    min-height: 38px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: none;
                            `,
                            css`
                                max-width: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    orderDetailsContainer: {
        css: css`
            margin-top: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    orderDetailLabel: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: #f4f3f1;
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    customRequest: {
        css: css``,
    },
    customRequestDropDown: {
        css: css``,
    },
    policyContainer: {
        css: css`
            margin-top: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    policyheadinglabel: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: #f4f3f1;
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    policySubheadinglabel: {
        css: css`
            padding: 0 20px 20px;
            display: block;
        `,
    },
    custContainer: {
        css: css`
            margin-top: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 100%;
            height: 100%;
            display: block;
            padding: 0;
        `,
    },
    custLabel: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: #f4f3f1;
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
        `,
    },
    custField: {
        css: css`
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            padding: 0 20px 20px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },

    custTextBox: {
        cssOverrides: {
            inputSelect: css`
                width: auto;
            `,
            formField: css`
                margin-top: 14px;
                width: 32%;
                flex-direction: column;
                align-items: center;
                label {
                    width: 100%;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 48%;
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    //height: 20px !important;
                    width: 100% !important;
                    max-width: 340px;
                    padding: 5px 12px !important;
                    min-height: 38px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: none;
                            `,
                            css`
                                max-width: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    submitButton: {
        css: css`
            padding: 10px;
            margin-top: 30px;
            min-height: 40px;
            width: 119px;
            border-radius: 0.5em;
        `,
    },
    buttonContainer: {
        css: css`
            margin-top: 20px;
        `,
    },
    table: {
        css: css`
            th,
            tr,
            td {
                border: none;
                height: none !important;
            }
            th {
                text-align: start !important;
                height: 16px !important;
            }
            tr {
                background-color: white !important;
                &:nth-child(even) {
                    background: white !important ;
                }
            }
            td {
                padding: 0px 2px !important;
                height: 5px;
                input {
                    height: 30px !important;
                }
            }
        `,
    },
    tableTextBox: {
        css: css`
            border-radius: 5px !important;
        `,
    },
    requestContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            align-items: flex-start;
            padding: 0 20px 10px;
            margin-bottom: 10px;
        `,
    },
    requestLine: {
        css: css`
            margin-right: 20px;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            margin-bottom: 10px;
            line-height: 22px;
            color: ${getColor("text.main")};
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 14px;
                    `,
                    css`
                        font-size: 14px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    depositContainer: {
        css: css`
            display: flex;
            justify-content: flex-start;
            margin-bottom: 10px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-wrap: wrap;
                        flex-direction: column;
                    `,
                    css`
                        flex-wrap: wrap;
                        flex-direction: column;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    DatePickerContainer: {
        css: css`
            display: block;
        `,
    },
    DateLabel: {
        css: css`
            margin-right: 164px;
            margin-top: 10px;
        `,
    },

    DatePicker: {
        cssOverrides: {
            formInputWrapper: css`
                align-items: center;
                margin-top: 5px;
                margin-right: 3px;
                display: flex;
                &::after {
                    content: "Now";
                    margin-left: 10px;
                }
            `,
        },
    },
    tableCells: {
        css: css``,
    },
    tableContainer: {
        css: css`
            padding: 0 20px 20px;
            display: block;
            table[class^="DataTableStyle"] {
                width: 100%;
            }
        `,
    },
    listStyle: {
        cssOverrides: {
            inputSelect: css`
                width: auto;
            `,
            formField: css`
                margin-top: 14px;
                width: 32%;
                flex-direction: column;
                align-items: center;
                label {
                    width: 100%;
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 100%;
                        `,
                        css`
                            width: 48%;
                        `,
                        null,
                        null,
                    ])}
            `,
            formInputWrapper: css`
                width: 100%;
                margin-top: 0px !important;
                input {
                    width: 100% !important;
                    max-width: 340px;
                    padding: 5px 12px !important;
                    min-height: 38px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                max-width: none;
                            `,
                            css`
                                max-width: none;
                            `,
                            null,
                            null,
                            null,
                        ])}
                }
                > div span[class^="IconWrapper"] {
                    right: 42px;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                right: 5px;
                            `,
                            css`
                                right: 5px;
                            `,
                            css`
                                right: 10px;
                            `,
                            null,
                            null,
                        ])}
                }
            `,
        },
    },
    lableDivone: {
        css: css`
            padding: 10px 30px;
            display: flex;
            flex-direction: column;
            font-weight: bold;
        `,
    },
    lableDivtwo: {
        css: css`
            padding: 10px 30px;
        `,
    },
    textOne: {
        css: css`
            margin-top: 20px;
        `,
    },
    textAreaEmail: {
        css: css`
            resize: none;
        `,
    },
    container: {
        css: css`
            display: flex;
            gap: 20px;
            padding: 10px 30px;
        `,
    },
    note: {
        css: css`
            font-weight: bold;
        `,
    },
    signatureTextField: {
        css: css`
            width: 50%;
        `,
    },
    orderDate: {
        css: css`
            width: 50%;
        `,
    },
    checkBoxContainer: {
        css: css`
            padding: 30px;
            padding: 10px 30px;
        `,
    },
    checkboxData: {
        css: css`
            margin-right: 10px;
        `,
    },
    checkboxText: {
        css: css`
            color: black;
            font-weight: bold;
            text-transform: capitalize;
        `,
    },
    informativeLine: {
        css: css`
            color: black;
        `,
    },
    informativeLineContainer: {
        css: css`
            padding: 10px 30px;
        `,
    },
    buttonWrapper: {
        css: css`
            display: flex;
            justify-content: flex-end;
            border-top: 1px solid ${COLORS.whisperGrey};
            padding: 10px 30px;
        `,
    },
    sendOrder: {
        css: css`
            margin-left: 10px;
            border-radius: 0px;
        `,
    },
    closeButton: {
        css: css`
            background-color: white;
            border-radius: 0px;
            color: black;
            &:hover {
                background-color: white;
                border-radius: 0px;
                color: black;
            }
            > span {
                color: black !important;
            }
        `,
    },
    billingLable: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            border: 1px solid ${getColor("common.border")};
            background: #f4f3f1;
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    Link: {
        css: css`
            font-weight: bold;
            margin-left: 3px;
            &:hover {
                text-decoration: underline;
            }
        `,
    },
    sameBillingText: {
        css: css`
            margin-right: 20px;
        `,
    },
    upperText: {
        css: css`
            padding-right: 30px;
            padding-top: 20px;
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                ])}
        `,
    },
    emailContainer: {
        css: css`
            padding: 10px 30px;
        `,
    },
    emailText: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.mediumbold} !important;
            font-size: ${TYPOGRAPHY.size.large} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
            color: ${getColor("text.main")} !important;
            &:last-of-type {
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.base} !important;
                font-size: ${TYPOGRAPHY.size.small} !important;
                line-height: ${TYPOGRAPHY.lineHeight.xbase} !important;
                color: ${getColor("text.main")} !important;
            }
        `,
    },
    productTittle: {
        css: css`
            padding: 14px 0px 15px 20px;
            width: 100%;
            height: 100%;
            background: #f4f3f1;
            display: inline-block;
            font-family: "Mulish";
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 26px;
            color: ${getColor("text.main")};
            /* margin-bottom: 20px; */
        `,
    },
    contactDetail: {
        css: css`
            border: 1px solid ${getColor("common.border")};
            margin-bottom: 20px;
        `,
    },
    sectionHeading: {
        css: css`
            display: flex;
            justify-content: space-between;
            padding: 15px 0px 15px 20px;
            background: ${getColor("secondary")};
            font-family: ${TYPOGRAPHY.fontFamily.title};
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold};
            font-size: ${TYPOGRAPHY.size.large};
            line-height: ${TYPOGRAPHY.lineHeight.medium};
            color: ${getColor("text.main")}; ;
        `,
    },
    Greeting: {
        css: css`
            font-size: 28px;
            font-weight: bold;
            text-transform: capitalize;
            margin-bottom: 10px;
        `,
    },
    shipTocheckboxCOntainer: {
        css: css`
            padding-right: 20px;
        `,
    },
    billingTitle: {
        css: css`
            padding: 20px;
        `,
    },
    termsContainer: {
        css: css`
            margin: 15px 0;
        `,
    },
    creditcardFrom: {
        css: css`
            display: block;
            margin: 10px 0;
        `,
    },
};

const styles = CustomGetQuoteFormStyles;

const CustomGetQuoteForm = ({
    feet,
    lengthFeet,
    lengthInches,
    inch,
    price,
    roundfeet,
    roundinch,
    widthFeet,
    widthInch,
    selectedShape,
    customData,
    userDetails,
    loadCurrentCountries,
    submitCustomOrder,
    createCustomerInfo,
    countries,
    product,
    closeHandler,
    currentShape,
    leadTime,
    acctualPrice,
    language,
}: Props) => {
    useEffect(() => {
        loadCurrentCountries();
        if (countries) {
            countries;
        }
    }, []);
    const requestOptions = [{ optionText: "Quote" }, { optionText: "Order" }];

    const [request, setRequest] = useState(requestOptions[0].optionText);
    const depoisteOptions = [
        { optionText: "Select an Option" },
        { optionText: "Credit Card" },
        { optionText: "check" },
    ];

    const [deposit, setDeposit] = useState(depoisteOptions[0].optionText);
    const [poNumber, setpoNumber] = useState("");
    const [checkNumber, setcheckNumber] = useState("");
    const [sidemark, setSidemark] = useState("");
    const [quantity, setquantity] = useState("");
    const [orderDate, setorderDate] = useState<any>();
    const [signature, setSignature] = useState(userDetails?.companyName);
    const [comment, setComment] = useState("");
    const [shipToName, setShipToName] = useState("");
    const [street1, setstreet1] = useState("");
    const [street2, setstreet2] = useState("");
    const [street3, setstreet3] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState<string>("");
    const [zipCode, setZipCode] = useState("");
    const [phone, setPhone] = useState("");
    const toasterContext = useContext(ToasterContext);
    const [states, setStates] = useState<StateModel[]>([]);
    const [businessLocationState, setLocationState] = useState("");
    const [shipToDetails, setShipToDetails] = useState(false);
    const [showTerms, setShowTerms] = useState(false);
    const [productDescription, setProductDescription] = React.useState("");
    const [email, setEmail] = useState(customData.email);
    const [checkBoxState, setCheckBoxState] = React.useState(false);

    const selectedCountry = countries?.find((c: { abbreviation: string }) => c.abbreviation === "US");
    useEffect(() => {
        setStates(selectedCountry?.states || []);
        setCountry(selectedCountry?.name || "");
    }, [selectedCountry]);

    // const depositoptions = [{ optionText: "Select an Option" }, { optionText: "CreditCard" }, { optionText: "Check" }];

    const poNumberHandler = (e: any) => {
        validateHandler(e.target);
        setpoNumber(e.target.value);
    };
    const checkNumberHandler = (e: any) => {
        validateHandler(e.target);
        setcheckNumber(e.target.value);
    };

    const sidemarkHandler = (e: any) => {
        validateHandler(e.target);
        setSidemark(e.target.value);
    };
    const quantityHandler = (e: any) => {
        validateHandler(e.target);
        setquantity(e.target.value);
    };
    const emailChangeHandler = (e: any) => {
        validateHandler(e.currentTarget);
        setEmail(e.target.value);
    };
    const signatureHandler = (e: any) => {
        validateHandler(e.target);
        setSignature(e.target.value);
    };
    const commentHandler = (e: any) => {
        // validateHandler(e);
        setComment(e.target.value);
    };
    const shipToNameHandler = (e: any) => {
        validateHandler(e.target);
        setShipToName(e.target.value);
    };
    const streetHandler = (e: any) => {
        validateHandler(e.target);
        setstreet1(e.target.value);
    };
    const street2Handler = (e: any) => {
        setstreet2(e.target.value);
    };
    const street3Handler = (e: any) => {
        setstreet3(e.target.value);
    };
    const cityHandler = (e: any) => {
        validateHandler(e.target);
        setCity(e.target.value);
    };
    const countryHandler = (e: any) => {
        validateHandler(e.target);
        setCountry(e.target.value);
    };
    const zipCodeHandler = (e: any) => {
        const formattedValue = e.target.value.replace(/^(\d{5})(\d{4})$/, "$1-$2");
        validateHandler(e.target);
        setZipCode(formattedValue);
    };
    const phoneHandler = (e: any) => {
        const cleanedValue = e.target.value.replace(/\D/g, "");
        const formattedValue = cleanedValue.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        e.target.value=cleanedValue
        validateHandler(e.target);
        setPhone(formattedValue);
    };

    const handleFormOfDeposit = (value: string) => {
        validateHandler(value);
        setDeposit(value);
    };

    const checkBoxStateHandler = (e: any) => {
        validateHandler(e.target);
        setCheckBoxState(!checkBoxState);
    };
    const handleLocationState = (value: string) => {
        validateHandler(value);
        setLocationState(value);
    };
    const [timeOfDay, setTimeOfDay] = React.useState("");
    /** ************************Code */

    const [formErrors, setFormErrors] = React.useState<FormErrorsStateType>(intialErrorFormState);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const validateSubmitDisabled = (errorsState: FormErrorsStateType) => {
        return Object.keys(errorsState).length !== 0;
    };
    const validateHandler = (
        input: HTMLInputElement | HTMLSelectElement | any,
        customValidation?: CallbackType,
    ): void => {
        const inputObject: InputObjectType = {
            name: input.name,
            value: input.value,
        };
        const validatorConfig = NewCustomerValidatorConfig[input.name as keyof ValidatorConfigType];
        const isValidate: ErrorObjectType | undefined = validate(inputObject, validatorConfig, customValidation);

        if (isValidate === undefined) {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        } else {
            setFormErrors({
                ...formErrors,
                [input.name]: isValidate ? isValidate.errorMsg : isValidate,
            });
        }
        if (!validatorConfig?.required && input.value === "") {
            delete formErrors[input.name as keyof FormErrorsStateType];
            setFormErrors(formErrors);
        }
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    };

    /** ******************************** */

    React.useEffect(() => {
        const date = getLocalizedDateTime({
            dateTime: new Date(),
            language,
            options: {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
            },
        });

        setorderDate(date);
        const currentDate = new Date(date);
        const currentHour = currentDate.getHours();
        let timeOfDay;
        if (currentHour < 12) {
            timeOfDay = "morning";
        } else if (currentHour >= 12 && currentHour < 17) {
            timeOfDay = "afternoon";
        } else {
            timeOfDay = "evening";
        }
        setTimeOfDay(timeOfDay);
    }, []);

  
    useEffect(() => {
        if (
            poNumber &&
            city &&
            country &&
            checkBoxState &&
            shipToName &&
            street1 &&
            zipCode &&
            phone &&
            (deposit  !== "Select an Option") &&
            quantity &&
            quantity !== "0" &&
            orderDate &&
            signature &&
            businessLocationState &&
            businessLocationState !== "Select" &&
            email &&
            Object.keys(formErrors).length !== 0
        ) {
            if (deposit === "check") {
                if (checkNumber && checkNumber !== "0") {
                    setIsButtonDisabled(false);
                } else {
                    setIsButtonDisabled(true);
                }
            } else {
                setIsButtonDisabled(false);
            }
        }
    }, [
        poNumber,
        checkBoxState,
        city,
        country,
        shipToName,
        street1,
        zipCode,
        phone,
        deposit,
        quantity,
        orderDate,
        email,
        signature,
        businessLocationState,
        checkNumber,
    ]);

    const handleShipTo = () => {
        if (shipToDetails === false) {
            setShipToDetails(true);
            setShipToName(userDetails?.companyName || "");
            setstreet1(userDetails?.address1 || "");
            setstreet2(userDetails?.address2 || "");
            setstreet3(userDetails?.address3 || "");
            setZipCode(userDetails?.postalCode || "");
            setCity(userDetails?.city || "");
            setPhone(userDetails?.phone || "");
            handleLocationState(userDetails?.state?.name || "");
        } else {
            setShipToDetails(false);
            setShipToName("");
            setstreet1("");
            setstreet2("");
            setstreet3("");
            setZipCode("");
            setCity("");
            setPhone("");
            handleLocationState("");
            setIsButtonDisabled(true);
        }
    };

    React.useEffect(() => {
        setIsButtonDisabled(validateSubmitDisabled(formErrors));
    }, [formErrors]);
    React.useEffect(() => {
        if (currentShape === "Rectangle") {
            setProductDescription(
                `${product?.productTitle}-${widthFeet}${widthInch}${lengthFeet}${lengthInches} (${
                    widthFeet && widthFeet > 0 && widthFeet
                }${widthInch && widthInch > 0 && `'${widthInch}`}" X ${lengthFeet && lengthFeet > 0 && lengthFeet}${
                    lengthInches && lengthInches > 0 && `'${lengthInches}`
                }"{" "}${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Square") {
            setProductDescription(
                `${product?.productTitle}-${feet}${inch}SQ (${feet && feet > 0 ? feet : 0}'${
                    inch && inch > 0 && inch
                }" ${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Round") {
            setProductDescription(
                `${product?.productTitle}-${roundfeet}${roundinch}RD (${roundfeet && roundfeet > 0 && `${roundfeet}'`}${
                    roundinch && roundinch > 0 && `${roundinch}"`
                } ${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Oval") {
            setProductDescription(
                `${product?.productTitle}-${widthFeet}${widthInch}${lengthFeet}${lengthInches}OV (${
                    widthFeet && widthFeet > 0 && `${widthFeet}'`
                }${widthInch && widthInch > 0 && `${widthInch}"`} X ${
                    lengthFeet && lengthFeet > 0 && `${lengthFeet}'`
                }${lengthInches && lengthInches > 0 && `${lengthInches}"`}{" "}${currentShape.toUpperCase()})`,
            );
        }
        if (currentShape === "Octagon") {
            setProductDescription(
                `${product?.productTitle}-${roundfeet}${roundinch}OC (${roundfeet && roundfeet > 0 && `${roundfeet}'`}${
                    roundinch && roundinch > 0 && `${roundinch}"`
                } ${currentShape.toUpperCase()})`,
            );
        }
    }, [widthFeet, widthInch, lengthFeet, lengthInches, currentShape, roundfeet, roundinch, feet, inch]);
    const submitHandler = () => {
        submitCustomOrder({
            ProductNumber: product?.productNumber,
            Shape: currentShape,
            WidthFeet: widthFeet && widthFeet > 0 ? widthFeet : 0,
            WidthInches: widthInch && widthInch > 0 ? widthInch : 0,
            LengthFeet: lengthFeet && lengthFeet > 0 ? lengthFeet : 0,
            LengthInches: lengthInches && lengthInches > 0 ? lengthInches : 0,
            SideFeet: feet && feet > 0 ? feet : 0,
            Sideinches: inch && inch > 0 ? inch : 0,
            DiameterFeet: roundfeet && roundfeet > 0 ? roundfeet : 0,
            DiameterInches: roundinch && roundinch > 0 ? roundinch : 0,
            PoNumber: poNumber,
            Sidemark: sidemark,
            Quantity: quantity as unknown as number,
            Description: productDescription,
            Price: price,
            CustomSize: `${product?.productNumber.toLowerCase().endsWith("-cstd") ? "STANDARD" : "EXPEDITED"}`,
            LeadTime: leadTime || "",
            Comment: comment,
            Signature: userDetails?.companyName,
            QuoteDate: orderDate,
            ItemPrice: acctualPrice || "",
            CheckNumber: checkNumber,
            PaymentType: deposit,
            STCompanyName: shipToName,
            STAddress1: street1,
            STAddress2: street2,
            STAddress3: street3,
            STPostalCode: zipCode,
            STCity: city,
            STState: businessLocationState,
            STCountry: country,
            STPhoneNo: phone,
            EmailList: email,
            Subject: product?.productNumber.toLowerCase().endsWith(Constant.customProduct)
                ? "Custom Rug Pad Order"
                : "Custom Rug Order",
            onSuccess: (result: any) => {
                closeHandler();
                setIsButtonDisabled(true);

                toasterContext.addToast({
                    body: translate(`Submitted Successfully`),
                    messageType: "success",
                });
            },

            onComplete(resultProps: any) {
                if (resultProps?.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    // eslint-disable-next-line react/no-this-in-sfc
                    this.onSuccess?.(resultProps?.apiResult);
                }
            },
            // onComplete(result) {
            //     closeHandler();
            //     toasterContext.addToast({
            //         body: translate(`Submitted Successfully`),
            //         messageType: "success",
            //     });
            // },
        });
    };

    const customQuoteType = product?.productNumber.toLowerCase().endsWith("-cstd")
        ? translate("Standard")
        : translate("Expedited");

    return (
        <>
            <StyledWrapper {...styles.shippingContainer}>
                <StyledWrapper>
                    <StyledWrapper {...styles.upperText}>
                        <Typography {...styles.Greeting}>Good {timeOfDay},</Typography>
                        <Typography>Please fill in the following fields of the form:</Typography>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.contactDetail}>
                    <StyledWrapper {...styles.billingLable}>
                        <Typography> Billing Address</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.shippingField}>
                        <Typography as="p" {...styles.billingTitle}>
                            {userDetails?.companyName} <br /> {userDetails?.address1} {userDetails?.address2}{" "}
                            {userDetails?.address3} {userDetails?.address4} <br /> {userDetails?.country?.name},{" "}
                            {userDetails?.postalCode} <br /> {userDetails?.phone}
                        </Typography>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.contactDetail}>
                    <StyledWrapper {...styles.sectionHeading}>
                        <Typography>Shipping Details</Typography>
                        <Typography {...styles.shipTocheckboxCOntainer}>
                            <Checkbox
                                checked={shipToDetails}
                                {...styles.checkboxData}
                                onChange={() => handleShipTo()}
                            ></Checkbox>
                            Same as Billing Address
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.contactSection}>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Ship To Name")}
                                placeholder={translate("Ship To Name")}
                                value={shipToName}
                                onChange={(e: any) => shipToNameHandler(e)}
                                required
                                name="shipToName"
                                data-test-selector="getquoteform_shiptoname"
                                error={!!formErrors.shipToName && formErrors.shipToName}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.shipToName ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Ship To Street 1")}
                                placeholder={translate("Ship To Street 1")}
                                value={street1}
                                required
                                onChange={e => streetHandler(e)}
                                name="street1"
                                data-test-selector="getquoteform_street1"
                                error={!!formErrors.street1 && formErrors.street1}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.street1 ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Ship To Street 2")}
                                placeholder={translate("Ship To Street 2")}
                                value={street2}
                                onChange={e => street2Handler(e)}
                                name="street2"
                                data-test-selector="getquoteform_street2"
                                // onBlur={e => validateHandler(e.currentTarget)}
                                // error={!!formErrors.street2 && formErrors.street2}
                                // iconProps={{
                                //     color: "danger",
                                //     src: formErrors.street2 ? AlertTriangle : undefined,
                                // }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Ship To Street 3")}
                                placeholder={translate("Ship To Street 3")}
                                value={street3}
                                onChange={e => street3Handler(e)}
                                name="street3"
                                data-test-selector="getquoteform_street3"
                                // onBlur={e => validateHandler(e.currentTarget)}
                                // error={!!formErrors.street3 && formErrors.street3}
                                // iconProps={{
                                //     color: "danger",
                                //     src: formErrors.firstName ? AlertTriangle : undefined,
                                // }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Ship To Zip Code")}
                                placeholder={translate("Ship To Zip Code")}
                                value={zipCode}
                                required
                                onChange={e => zipCodeHandler(e)}
                                name="zipCode"
                                data-test-selector="getquoteform_zipcode"
                                maxLength={10}
                                error={!!formErrors.zipCode && formErrors.zipCode}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.firstName ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Ship To City")}
                                placeholder={translate("Ship To City")}
                                value={city}
                                required
                                onChange={e => cityHandler(e)}
                                name="city"
                                data-test-selector="getquoteform_city"
                                error={!!formErrors.city && formErrors.city}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.city ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <Select
                                label={translate("Ship to State")}
                                {...styles.dropdown}
                                onChange={e => handleLocationState(e.target.value)}
                                value={businessLocationState}
                                required
                            >
                                <option value="Select">--Select--</option>
                                {states?.map(state => (
                                    <option value={state.name} key={state.id}>
                                        {state.name}
                                    </option>
                                ))}
                            </Select>
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Ship to Country")}
                                // value={phone}
                                placeholder="Ship to Country"
                                data-test-selector="Country"
                                // onChange={e => handlePhoneNumber(e.currentTarget.value)}
                                // error={isSubmitted && phoneNumberError}
                                value={country}
                                required
                                disabled={Boolean(country.length)}
                                onChange={e => countryHandler(e)}
                                name="country"
                                error={!!formErrors.country && formErrors.country}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.country ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.emailTextField}
                                label={translate("Customer Phone")}
                                placeholder="Customer Phone"
                                // type="number"
                                value={phone}
                                onChange={e => phoneHandler(e)}
                                name="phone"
                                required
                                data-test-selector="getquoteform_customerphone"
                                autoComplete="off"
                                maxLength={19}
                                error={!!formErrors.phone && formErrors.phone}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.phone ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.contactDetail}>
                    <StyledWrapper {...styles.sectionHeading}>Order Details</StyledWrapper>
                    <StyledWrapper {...styles.lableDivone}>
                        {selectedShape === "Square" && (
                            <Typography {...styles.qunatityText}>
                                {product?.productTitle} ({feet && feet > 0 ? `${feet}'` : ""}
                                {inch && inch > 0 && `${inch}"`}{" "}
                                {selectedShape && selectedShape.length > 0 && selectedShape})
                            </Typography>
                        )}
                        {selectedShape === "Round" && (
                            <Typography {...styles.qunatityText}>
                                {product?.productTitle} ({roundfeet && roundfeet > 0 && `${roundfeet}'`}
                                {roundinch && roundinch > 0 && `${roundinch}"`}{" "}
                                {selectedShape && selectedShape.length > 0 && selectedShape})
                            </Typography>
                        )}
                        {selectedShape === "Rectangle" && (
                            <Typography>
                                {product?.productTitle}({lengthFeet && lengthFeet > 0 && `${lengthFeet}'`}
                                {lengthInches && lengthInches > 0 && `${lengthInches}"`} x
                                {widthFeet && widthFeet > 0 && `${widthFeet}'`}
                                {widthInch && widthInch > 0 && `${widthInch}"`}{" "}
                                {selectedShape && selectedShape.length > 0 && selectedShape})
                            </Typography>
                        )}
                    </StyledWrapper>
                    <StyledWrapper {...styles.contactSection}>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Account Number")}
                                placeholder={translate("Account Number")}
                                value={userDetails?.customerNumber}
                                disabled
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <Select
                                label={translate("Form of Deposit")}
                                onChange={e => handleFormOfDeposit(e.target.value)}
                                value={deposit}
                                {...styles.dropdown}
                                required
                            >
                                <option value="Select an Option">--Select--</option>
                                <option value="creditCard">{translate("Credit Card")}</option>
                                <option value="check">{translate("Check")}</option>
                            </Select>
                        </StyledWrapper>
                        {deposit === "check" && (
                            <StyledWrapper {...styles.contactField}>
                                <TextField
                                    {...styles.userNameTextField}
                                    label={translate("Check Number")}
                                    placeholder="Check Number"
                                    required={deposit === "check"}
                                    name="check"
                                    data-test-selector="getquoteform_check"
                                    onChange={e => checkNumberHandler(e)}
                                    value={checkNumber}
                                    error={!!formErrors.check && formErrors.check}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.check ? AlertTriangle : undefined,
                                    }}
                                />
                            </StyledWrapper>
                        )}

                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("PO Number")}
                                placeholder="PO Number"
                                type="text"
                                value={poNumber}
                                onChange={e => poNumberHandler(e)}
                                required
                                name="poNumber"
                                maxLength={30}
                                data-test-selector="getquoteform_poNumber"
                                error={!!formErrors.poNumber && formErrors.poNumber}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.poNumber ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                label={translate("Sidemark")}
                                placeholder="Sidemark"
                                onChange={e => sidemarkHandler(e)}
                                value={sidemark}
                                name="sidemark"
                                data-test-selector="getquoteform_sidemark"
                                // onBlur={e => validateHandler(e.currentTarget)}
                                // error={!!formErrors.sidemark && formErrors.sidemark}
                                // iconProps={{
                                //     color: "danger",
                                //     src: formErrors.sidemark ? AlertTriangle : undefined,
                                // }}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...styles.contactField}>
                            <TextField
                                {...styles.userNameTextField}
                                type="number"
                                label={translate("QTY")}
                                placeholder={translate("QTY")}
                                onChange={e => quantityHandler(e)}
                                value={quantity}
                                required
                                name="quantity"
                                min={0}
                                data-test-selector="getquoteform_quantity"
                                error={!!formErrors.quantity && formErrors.quantity}
                                iconProps={{
                                    color: "danger",
                                    src: formErrors.quantity ? AlertTriangle : undefined,
                                }}
                            />
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper>
                    <StyledWrapper {...styles.lableDivtwo}>
                        <StyledWrapper {...styles.textOne}>
                            <Typography>
                                {acctualPrice?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")} psf for {customQuoteType}{" "}
                                {leadTime} ={`$${price?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}{" "}
                            </Typography>
                        </StyledWrapper>
                        {product?.properties?.productType !== Constant.customProductType && (
                            <StyledWrapper {...styles.textOne}>
                                <Typography>***Minimum custom order: $500.00***</Typography>
                            </StyledWrapper>
                        )}
                        <StyledWrapper {...styles.textOne}>
                            <Typography>
                                Please Note : Our custom order terms have changed,
                                <Link {...styles.Link} onClick={() => setShowTerms(prev => !prev)}>
                                    Please Click here to view them.
                                </Link>
                            </Typography>
                        </StyledWrapper>
                    </StyledWrapper>

                    {showTerms && product?.properties?.productType === Constant.customProductType ? (
                        <StyledWrapper {...styles.termsContainer}>
                            <Typography {...styles.termsAndConditionNotes} as="p">
                                {Constant.customRugPadTermsHeading}
                            </Typography>

                            <Typography as="p" {...styles.addressLineOne}>
                                {siteMessage("TermsAndConditionCustomRugPad")}
                            </Typography>
                        </StyledWrapper>
                    ) : (
                        showTerms && (
                            <StyledWrapper {...styles.termsContainer}>
                                <Typography {...styles.termsAndConditionNotes} as="p">
                                    {Constant.customRugTermsHeading}
                                </Typography>

                                <Typography as="p" {...styles.addressLineOne}>
                                    {siteMessage("TermsAndConditions")}
                                </Typography>
                            </StyledWrapper>
                        )
                    )}
                    <StyledWrapper>
                        <StyledWrapper {...styles.emailContainer}>
                            <Typography>Send this order to following emails:</Typography>
                            <StyledWrapper>
                                {/* <Typography>{customData.email}</Typography> */}
                                <TextField
                                    {...styles.emailText}
                                    name="email"
                                    value={email}
                                    required
                                    type="text"
                                    // data-test-selector="createAccount_firstName"
                                    onChange={e => emailChangeHandler(e)}
                                    error={!!formErrors.email && formErrors.email}
                                    iconProps={{
                                        color: "danger",
                                        src: formErrors.email ? AlertTriangle : undefined,
                                    }}
                                    placeholder={translate("Email Address")}
                                    autoComplete="off"
                                />
                            </StyledWrapper>
                            <StyledWrapper>
                                <Typography>
                                    <Typography {...styles.note}>Note:</Typography> Please add semicolon(;) to the end
                                    of each email
                                </Typography>
                            </StyledWrapper>
                            <StyledWrapper>
                                <TextArea
                                    // label={translate("Comment")}
                                    placeholder={translate("Comment")}
                                    value={comment}
                                    onChange={e => commentHandler(e)}
                                    {...styles.textAreaEmail}
                                ></TextArea>
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                    <StyledWrapper {...styles.container}>
                        <TextField
                            {...styles.signatureTextField}
                            label={translate("Signature")}
                            placeholder={translate("Signature")}
                            value={signature}
                            onChange={e => signatureHandler(e)}
                            required
                        ></TextField>
                        <TextField
                            {...styles.orderDate}
                            label={translate("Order Date")}
                            placeholder={translate("Order Date")}
                            value={orderDate}
                            required
                            disabled
                            // onChange={ e => orderDateHandler(e)}
                        ></TextField>
                    </StyledWrapper>
                    <StyledWrapper {...styles.checkBoxContainer}>
                        <Checkbox
                            {...styles.checkboxData}
                            checked={checkBoxState}
                            onChange={e => checkBoxStateHandler(e)}
                        ></Checkbox>
                        <Typography {...styles.checkboxText}>{Constant.termsAndCondition}</Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.informativeLineContainer}>
                        <Typography {...styles.informativeLine}>
                            Please let us know if I can be of further assistance, you can email us to custom@surya.com
                            or by Phone: 877-275-7847.
                        </Typography>
                    </StyledWrapper>
                    <StyledWrapper {...styles.buttonWrapper}>
                        <Button {...styles.closeButton} onClick={closeHandler}>
                            Close
                        </Button>
                        <Button
                            {...styles.sendOrder}
                            onClick={submitHandler}
                            // type="submit"
                            disabled={isButtonDisabled}
                        >
                            Send Order
                        </Button>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomGetQuoteForm);
